// extracted by mini-css-extract-plugin
export var contrastLow = "_v-1";
export var externalLink = "_v-2";
export var externalLinkIcon = "_v-3";
export var link = "_v-0";
export var linkLabel = "_v-4";